import { RippleMode } from './modes/ripple';

export class Playlist {
  constructor({ manager, modes, removeAllInteractionListeners }) {
    this.manager = manager;
    // take list of modes and durations, calculate times
    this.modes = modes.map(([mode, duration, data]) => {
      return {
        mode,
        durationBeats: duration,
        startTime: 0,
        endTime: 0,
        data,
      }
    });
    let timeCumu = 0;
    this.modes.forEach(m => {
      const durationSecs = m.durationBeats / (120 / 60);
      m.startTime = timeCumu;
      m.endTime = timeCumu + durationSecs;
      timeCumu = m.startTime + durationSecs;
    });
    this.removeAllInteractionListeners = removeAllInteractionListeners;
    // setTimeout(()=> {
    //   console.info(`Playlist length: ${timeCumu} seconds (${(timeCumu / document.querySelector('audio').duration * 100).toFixed(1)}%)`);
    //   console.info(this.modes.map(({mode}) => mode.name.replace(`Mode`,'')).join('\n'))
    // }, 1000)
    this.activeMode = null;
  }
  update(time) {

    if (!time) {
      return;
    }

    const { manager } = this;
    // if it's time to change mode, do it
    const activeIndex = this.modes.findIndex(({endTime}) => endTime > time);
    
    if (activeIndex < 0) {
      return;
    }
    if (activeIndex > this.modes.length - 1) {
      // need to restart playlist
    }

    if (this.activeMode !== activeIndex) {
      const prevMode = manager.layer(0).name();
      const {mode, data} = this.modes[activeIndex];
      const interactiveModeNext = mode.name === 'BreakoutMode' || mode.name === 'TennisMode';
      if (interactiveModeNext) {
        this.removeAllInteractionListeners();
      }
      manager.layer(0).switchTo(mode, data);
      if (interactiveModeNext) {
        manager.layer(1).clear();
      } else if (manager.layer(1).name() !== 'RippleMode' || prevMode === 'LaunchMode')  {
        manager.layer(1).switchTo(RippleMode)
      }

      this.activeMode = activeIndex;
    }

  }
  skip() {
    // todo
  }
}
